import { Card, Col, Flex, Image, Layout, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import FormAntd from "components/form/FormProvide/FormAntd";
import styles from "../styles/Login.module.css";
import { FormInput } from "components/form/FormProvide";
import { useTranslation } from "react-i18next";
import { AuthBackground } from "components/layouts";
import { Content, Footer } from "antd/es/layout/layout";
import { useMediaQuery } from "react-responsive";
import Logo from "assets/images/logo_final_1_1.png";
import { Button } from "components/elements";

const AdminLogin = ({
    isLoading = false,
    doLoginForAdminAccess = () => { }
}) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
    const isPortrait = useMediaQuery({ orientation: 'portrait' });

    return (
        <AuthBackground showLanguageSwitcher>
            <Layout>
                <Content style={{
                    background: 'transparent',
                    justifyContent: "center",
                    textAlign: "center",
                    position: 'relative',
                    marginTop: isTabletOrMobile ? '60px' : '20px'
                }}>
                    <Row
                        style={!isPortrait && {
                            marginLeft: "30vw",
                            marginRight: "30vw"
                        }}>
                        <Col span={22} style={{ justifyContent: "center" }}>
                            <Image
                                preview={false}
                                width={"24vw"}
                                src={Logo}
                                style={{
                                    justifyContent: "center",
                                    textAlign: "center",
                                    margin: 30
                                }}
                            />
                        </Col>
                        <Col span={24}>
                            <FormAntd
                                form={form}
                                onFinish={doLoginForAdminAccess}
                            >
                                <FormItem
                                    shouldUpdate={(prev, curv) => { return false }}
                                >
                                    <Card
                                        className={styles.formContainer}
                                        styles={{ body: { padding: "0px" } }}
                                    >
                                        <Flex vertical style={{ paddingBottom: "2vw" }}>
                                            <span className={styles.formHeader}>
                                                {`${t("signin.label.signin")} (Admin)`}
                                            </span>
                                            <span className={styles.subHeader} style={{ fontSize: isTabletOrMobile ? "3vw" : "1vw" }}>
                                                {t("signin.label.sub_header")}
                                            </span>
                                        </Flex>
                                        <Flex vertical style={{ display: "flex", flexDirection: "column", gap: "2vw" }}>
                                            <FormInput
                                                name="email"
                                                size="large"
                                                placeholder={t("signin.placeholders.email")}
                                                required
                                            />
                                            <FormInput
                                                name="password"
                                                type="password"
                                                size="large"
                                                placeholder={t("signin.placeholders.password")}
                                                required
                                            />
                                        </Flex>

                                        <Space
                                            style={{
                                                marginTop: 20,
                                                width: "100%"
                                            }}
                                            direction="vertical"
                                            size={50}
                                        >
                                            <Button
                                                className={styles.button}
                                                disabled={isLoading}
                                                htmlType="submit"
                                                size="large"
                                            >
                                                <span style={{ fontSize: isTabletOrMobile ? "2vw" : "0.8vw" }}>
                                                    {t("signin.entity").toUpperCase()}
                                                </span>
                                            </Button>
                                        </Space>
                                    </Card>
                                </FormItem>
                            </FormAntd>
                        </Col>
                    </Row>
                </Content>

                <Footer style={{ backgroundColor: "transparent" }}>
                    <Flex vertical align="center">
                        <span style={{ color: "#757575" }}>{t("common.version")} 1.3.4</span>
                        <span style={{ color: "#757575" }}>
                            Copyright (c) by Bright Expert Company Limited. All Rights Reserved.
                        </span>
                    </Flex>
                </Footer>
            </Layout>
        </AuthBackground>
    )
}

export default AdminLogin;